module.exports = __webpack_public_path__ + "static/media/documentToken.1d9000b1.svg";